import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Space, Card, Form, Button, Typography, Radio, List, message, Skeleton } from 'antd';
import { CustomSwitch, CustomInput } from 'components/custom';
import ChatBotContext from 'hooks/chat-bot-context';
import BotSettingsService from '../../../api-services/bot-settings';
import { DeleteOutlined } from '@ant-design/icons';
import useLoading from 'hooks/use-loading';
import { useNavigate } from 'react-router';
const { Paragraph } = Typography;

function AccessibilitySettings() {
  const { selectedBot } = useContext(ChatBotContext);
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const [visibility, setVisibility] = useState('Public');
  const [whiteListedDomains, setWhitelistedDomains] = useState([]);
  const [newDomain, setNewDomain] = useState('');
  const [skeleton, setSkeleton] = useState(true);
  const [isSpecificDomainsAllowed, setIsSpecificDomainsAllowed] = useState(false);


  const onChange = (e) => {
    setVisibility(e.target.value);
  };

  useEffect(() => {
    const getSettings = async () => {
      const result = await BotSettingsService.getAccessiblitySettings(selectedBot);
      if(result && result.data) {
        setVisibility(result.data.visibility ? 'Public' : 'Private');
        setWhitelistedDomains(result.data.white_domains);
        setIsSpecificDomainsAllowed(result.data.white_domains.length > 0);
        setSkeleton(false);
      }
    };

    if (selectedBot) {
      getSettings();
    } else {
      navigate('/chatbots');
    }
  }, [selectedBot]);

  const handleSaveSettings = async () => {
    const payload = {
      visibility: visibility === 'Public',
      white_domains: isSpecificDomainsAllowed ? whiteListedDomains : [],
    };

    try {
      setLoading(true);
      const result = await BotSettingsService.updateBotAccessControl(selectedBot, payload);
      
      if (result?.data) {
        // Process the response data and update the chat with the response message
        message.destroy();
        message.success('Access control updated successfully');
      }
    } catch (error) {
      // Handle error if the API request encounters an exception
      console.error('API request error:', error);
    } finally {
      setLoading(false);
    }
  };

  /* eslint-disable */
  const handleAddDomain = () => {
    const domainRegex =
      /^(?:(?:(?:[a-zA-z\-]+)\:\/{1,3})?(?:[a-zA-Z0-9])(?:[a-zA-Z0-9\-\.]){1,61}(?:\.[a-zA-Z]{2,})+|\[(?:(?:(?:[a-fA-F0-9]){1,4})(?::(?:[a-fA-F0-9]){1,4}){7}|::1|::)\]|(?:(?:[0-9]{1,3})(?:\.[0-9]{1,3}){3}))(?:\:[0-9]{1,5})?$/;
    const localRegex = /(localhost)./;
    console.log(domainRegex.test(newDomain), localRegex.test(newDomain));

    if (domainRegex.test(newDomain) === false && localRegex.test(newDomain) === false) {
      message.error('Please enter a valid domain.');
      return;
    }

    setWhitelistedDomains([...whiteListedDomains, newDomain]);
    setNewDomain('');
  };

  const handleDeleteDomain = (domain) => {
    const updatedDomains = whiteListedDomains.filter((item) => item !== domain);
    setWhitelistedDomains(updatedDomains);
  };

  return (
    <div>
      <h2>Access Control</h2>

      <Row>
        <Col span={18}>
          <Space size='middle' direction='vertical' style={{ display: 'flex' }}>
            <Card>
              {!skeleton && (
                <Form id='accessibility-settings' form={form} layout='vertical'>
                  <Row gutter={24} className='setting-tab' justify='space-between' align='middle'>
                    <Col>
                      <Form.Item label='Visibilty' name='visibility' style={{ marginBlockEnd: 0 }}>
                        <Radio.Group onChange={onChange} value={visibility} defaultValue={visibility}>
                          <Space direction='vertical'>
                            <Radio value={'Public'}>Public</Radio>
                            <Radio value={'Private'}>Private</Radio>
                          </Space>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item>
                        <Button type='primary' onClick={handleSaveSettings}>
                          Save
                        </Button>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Paragraph type='info' style={{ marginBlockStart: 10 }}>
                        Public&rsquo;: Anyone can access the chatbot through script provided in Embed on Script.
                      </Paragraph>
                      <Paragraph type='info' style={{ marginBlockStart: 10 }}>
                        &rsquo;Private&rsquo;: Can only be accessed through this dashboard
                      </Paragraph>
                    </Col>
                  </Row>
                  <Row gutter={24} align='middle'>
                    <Col>
                      <Form.Item
                        required
                        style={{
                          marginBlockEnd: 20,
                          marginBlockStart: 20,
                        }}>
                        <CustomSwitch state={isSpecificDomainsAllowed}  setState={setIsSpecificDomainsAllowed} disabled={visibility === 'Private' ? 'disabled': '' } />
                        <label>&nbsp; Allow access from these domain only</label>
                      </Form.Item>
                    </Col>
                  </Row>
                  {!isSpecificDomainsAllowed || visibility !== 'Private' && (
                    <>
                      <Row gutter={16}>
                        <Col xs={20} sm={16} md={12} lg={9}>
                          <Form.Item required>
                            <CustomInput placeholder='example.com' state={newDomain} setState={setNewDomain} />
                          </Form.Item>
                        </Col>
                        <Col>
                          <Form.Item>
                            <Button type='primary' onClick={handleAddDomain} disabled={newDomain.trim() === ''}>
                              Add More
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                      <List
                        dataSource={whiteListedDomains}
                        renderItem={(domain) => (
                          <List.Item>
                            <List.Item.Meta title={domain} />
                            <Space>
                              <Button
                                type='link'
                                icon={<DeleteOutlined />}
                                onClick={() => handleDeleteDomain(domain)}
                              />
                            </Space>
                          </List.Item>
                        )}
                      />
                    </>
                  )}
                </Form>
              )}
              {skeleton && <Skeleton active />}
            </Card>
          </Space>
        </Col>
      </Row>
    </div>
  );
}

export default AccessibilitySettings;
